// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__y4k_3","left":"styles_left__1nzJG"};